"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _FlexTabContainer = _interopRequireDefault(require("./../../FlexTabContainer"));
var TabPane = _FlexTabContainer["default"].TabPane;
var pc_self_scroll_num = 100;
function isInViewPort(element) {
  // const viewWidth = window.innerWidth || document.documentElement.clientWidth;
  var viewHeight = window.innerHeight || document.documentElement.clientHeight;
  var top = element.getBoundingClientRect().top;
  return top > 0 && top < viewHeight;
  // return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight;
}
function flex_scroll(origin, val) {
  var easing = 0.1;
  origin += (val - origin) * easing;
  if (Math.abs(Math.floor(origin) - Math.floor(val)) > 10) {
    window.scrollTo(0, origin - pc_self_scroll_num);
    requestAnimationFrame(function () {
      flex_scroll(origin, val);
    });
  }
}
function SelfNavigation(props) {
  var _a = props || {},
    configuration = _a.configuration,
    style = _a.style;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'self-pc-navigation-container',
    style: style || {}
  }, /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], {
    onCallback: function onCallback(v) {
      var getNodePos = document.querySelector(v.id);
      if (getNodePos && !isInViewPort(getNodePos)) {
        var _scroll_val = getNodePos.offsetTop || 0;
        var scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
        flex_scroll(scrollTop, _scroll_val);
      }
    }
  }, configuration.map(function (item, _index) {
    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      key: _index,
      tabIndex: _index + 1,
      title: item.label,
      id: item.anchorId
    });
  })));
}
var _default = exports["default"] = SelfNavigation;